import $ from 'jquery';
import defaults from 'lodash/defaults';
import get from 'lodash/get';
const PRODUCT_CODE = 'data-pcode';
const SELECTORS = {
  totalCount: '#tr_top_heart_mhp_count',
  favHeart: '.fav_heart'
};

const CLASS_NAMES = {
  activated: 'favorite-button--active',
};
const REQUESTS = {
  heartProduct: {
    url: '/r/ajaxHeartProduct.jsp?',
    method: 'POST'
  },
};
const TRANSLATIONS = {
  favorite: get(window, 'rcProps.hearts.textFields.favorite', 'Favorite'),
  unfavorite: get(window, 'rcProps.hearts.textFields.unfavorite', 'Unfavorite'),
  addFavorite: get(window, 'rcProps.hearts.textFields.addFavorite', 'has been added to your favorites'),
  removeFavorite: get(window, 'rcProps.hearts.textFields.removeFavorite', 'has been removed from your favorites'),
  favoriteBrand: get(window, 'rcProps.hearts.textFields.favoriteBrand', 'Add this brand to your FAVORITES'),
  unfavoriteBrand: get(window, 'rcProps.hearts.textFields.unfavoriteBrand', 'Unfavorite this brand'),
}

defaults(init, {
  heartProductM: heartProductM,
  heartAll: heartAll,
  submitHeart : submitHeart,
  submitHeartBrand: updateHeartBrandPLP,
  updateHeartCount: updateHeartCount,
  SELECTORS: SELECTORS,
  CLASS_NAMES: CLASS_NAMES,
  REQUESTS: REQUESTS,
  TRANSLATIONS: TRANSLATIONS
});

function getActiveClass() {
  return window.rcProps && window.rcProps.favoriteActiveClass || CLASS_NAMES.activated;
}

function init(selector, delegateTo, paramProductCode) {
  var $el = $(selector);
  if (paramProductCode) {
    heartProductM(null, paramProductCode);
  } else if (!$el.data('plugin_hearting')) {
      $el.data('plugin_hearting', true); // Prevent duplicate events
      if (delegateTo) {
          $el.on('click', delegateTo, function(e) {
              e.preventDefault();
              var target = e.currentTarget;
              heartProductM(target, target.getAttribute(PRODUCT_CODE));
          });
      } else {
          $el.on('click', function(e) {
              e.preventDefault();
              var target = e.target;
              heartProductM(target, target.getAttribute(PRODUCT_CODE));
          });
      }
  }

  window.updateHeartBrandPLP = updateHeartBrandPLP;
  window.updateHeartBrandIndex = updateHeartBrandIndex;
  window.updateHeartBrandIndexWithTab = updateHeartBrandIndexWithTab;
  window.reloadDesignersList =  reloadDesignersList;
}
// Add / Update a key-value pair in the URL query parameters
function updateUrlParameter(uri, key, value) {
  var i = uri.indexOf('#');
  var hash = i === -1 ? ''  : uri.substr(i);
  uri = i === -1 ? uri : uri.substr(0, i);

  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    uri = uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    uri = uri + separator + key + "=" + value;
  }
  return uri + hash;
}
function heartProductM(elem, pcode, size, sectionUrl){
  var $span = $(elem);
  const $favoriteNotify = $span.next('.js-favorite-notify');
  const unfavoritedMessageNotif = $span.data('unfavorite-notification');
  const favoritedMessageNotif = $span.data('favorite-notification');
  const unfavoriteMessage = $span.data('unfavorite-message');
  const favoriteMessage = $span.data('favorite-message');
  const messageContainer = '.u-screen-reader';
  const activeClass = getActiveClass();

  if ($span.hasClass(activeClass)) {
    $span.removeClass(activeClass);
    $favoriteNotify.text(unfavoritedMessageNotif);
    $span.find(messageContainer).text(favoriteMessage);

    submitHeart('product', pcode, 'remove', size, sectionUrl);

    if(window.rcProps.removeItemOnUnhearted){
        var $citeDiv = $span.parents('.js-plp-container');
        $citeDiv.fadeOut();
        $citeDiv.remove();
        const $plpCount = $("#plp-item-count");
        let countRef = $plpCount.html();
        const itemCountDescriptionArr = countRef.split(' ');
        let count = parseInt($plpCount.data("count"), 10) || 0;
        if(count > 0) {
            count = count - 1;
        }
        let itemCountText = count.toLocaleString() ;
        const $textEl = $('#plp-item-text');
        if ($textEl.length > 0) {
            let text = '';
            if (count === 1) {
                text = $textEl.data("textone");
            } else {
                text = $textEl.data("text");
            }
            $textEl.html(text);
        } else if (itemCountDescriptionArr.length > 1) {
            itemCountText = itemCountText + ' ' + itemCountDescriptionArr[1];
        }
        $plpCount.html(itemCountText);
        $plpCount.data("count", count);

    }
  } else {
    var productSize = parseInt($(SELECTORS.totalCount).data('count'), 10);

    if (!window.rcProps.isApp) {
      if ((window.rcProps.isGuest && !(window.rcProps.hearts.enabledforGuest
          && productSize <= window.rcProps.hearts.maxCountGuest))
        || (!window.rcProps.isGuest && productSize > window.rcProps.hearts.maxCount)) {
        showExceedsLimitModal(pcode);
        return;
      }
    }

    return submitHeart('product', pcode, 'add', size, sectionUrl, function() {
      $favoriteNotify.text(favoritedMessageNotif);
      $span.find(messageContainer).text(unfavoriteMessage);
    }, elem, activeClass);
  }
}

function showExceedsLimitModal(productCode) {
  $.modal({
    url: "/content/favorites/fav-max-popup-markup",
    triggerOpen: true,
    onOpen: function () {
      if (window.rcProps.isGuest) {
        var _donde = $('#loadDnde');
        var refUrl = window.location.pathname + window.location.search;
        if(_donde && _donde.val()){
          refUrl = updateUrlParameter(refUrl, 'loadDnde', _donde.val());
        }

        $('#guestLimitPop, #fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?favcode=" + productCode + "&ref=" + encodeURIComponent(refUrl));
      }
    }
  });
}

window.showExceedsLimitModal = showExceedsLimitModal;

function updateHeartBrandPLP(elem, designer, callback) {
  const activeClass = getActiveClass();
  const $elem = $(elem);

  if ($elem.hasClass(activeClass) || $elem.data('is-active')) {
    $elem.removeClass(activeClass);
    $elem.find(".favorite-msg").html(TRANSLATIONS.favoriteBrand);
    $('#favorite-designer').find('p').html(designer + " " + TRANSLATIONS.removeFavorite);
    submitHeart("brand", designer, "remove");
  } else {
    if (!$elem.data('use-active-attr')) {
        $elem.addClass(activeClass);
    }

    $elem.find(".favorite-msg").html(TRANSLATIONS.unfavoriteBrand);
    $('#favorite-designer').find('p').html(designer + " " + TRANSLATIONS.addFavorite);
    submitHeart("brand", designer, "add");
  }
  if (callback && typeof callback === 'function') {
      callback();
  } else {
      $.modal({
          triggerOpen: true,
          open: "favorite-designer"
      });
  }
}

function updateHeartBrandIndex(elem, designer, isGuest) {
  const activeClass = getActiveClass();
  const gender = $('#home').data('gender');
  const $elem = $(elem);
  if ($elem.hasClass(activeClass)) {
    $elem.removeClass(activeClass);
    $elem.find('.u-screen-reader').html(TRANSLATIONS.favorite + " " + designer);
    $('#unfavorite-button').find('p').html(designer + " " + TRANSLATIONS.removeFavorite);

    if($elem.parents('#favorite-designer-list').length == 1) {
      return submitHeart("brand", designer, "remove").then(function () {
        location.reload();
      });
    } else {
      return submitHeart("brand", designer, "remove").then(function () {
        $.modal({
          triggerOpen:true,
          open: "unfavorite-button"
        });
      }).then(function () {
        return reloadFavoriteDesignerList(gender);
      });
    }
  } else {
    if (isGuest) {
      $('#favorite-designer-modal').find('#fav-modal-sign-in').attr('href', '/r/mobile/LoginPage.jsp?d=' + gender + '&favbrand=' + designer +
          '&ref=' + encodeURIComponent('/r/mobile/DesignerAZ.jsp?d=' + gender));
      $.modal({
        triggerOpen:true,
        open: "favorite-designer-modal"
      });
    } else {
      $elem.addClass(activeClass);
      $elem.find('.u-screen-reader').html(TRANSLATIONS.unfavorite + " " + designer);
      $('#favorite-button').find('p').html(designer + " " + TRANSLATIONS.addFavorite);
      return submitHeart("brand", designer, "add").then(function () {
        $.modal({
          triggerOpen:true,
          open: "favorite-button"
        });
      }).then(function () {
        return reloadFavoriteDesignerList(gender);
      });
    }
  }
}

function reloadDesignersList(tab, $element) {
    $.ajax({
        url: window.rcProps.designerListHref + '&tab=' + encodeURIComponent(tab),
        success: function (response){
            if ($element) {
                $(".designer-nav__link").removeClass('action-button--dark');
                $element.addClass('action-button--dark');
            }
            $("#designer-content").html(response);
        }
    });
}

function updateHeartBrandIndexWithTab(elem, designer, isGuest, tab, gender) {
    const activeClass = getActiveClass();
    const $elem = $(elem);
    if ($elem.hasClass(activeClass)) {
        $elem.removeClass(activeClass);
        $elem.find('.u-screen-reader').html(TRANSLATIONS.favorite + " " + designer);
        $('#unfavorite-button').find('p').html(designer + " " + TRANSLATIONS.removeFavorite);

        if($elem.parents('#favorite-designer-list').length == 1) {
            return submitHeart("brand", designer, "remove").then(function () {
                reloadDesignersList(tab);
            }).then(function () {
                $.modal({
                    triggerOpen:true,
                    open: "unfavorite-button"
                });
            });
        } else {
            return submitHeart("brand", designer, "remove").then(function () {
                return reloadDesignersList(tab);
            }).then(function () {
                $.modal({
                    triggerOpen:true,
                    open: "unfavorite-button"
                });
            });
        }
    } else {
        if (isGuest && !window.rcProps.hearts.enabledforGuest) {
            $('#favorite-designer-modal').find('#fav-modal-sign-in').attr('href', '/r/mobile/LoginPage.jsp?d=' + gender + '&favbrand=' + designer +
                '&ref=' + encodeURIComponent(location.pathname + '?d=' + gender + '&tab=' + tab));
            $.modal({
                triggerOpen:true,
                open: "favorite-designer-modal"
            });
        } else {
            $elem.addClass(activeClass);
            $elem.find('.u-screen-reader').html(TRANSLATIONS.unfavorite + " " + designer);
            $('#favorite-button').find('p').html(designer + " " + TRANSLATIONS.addFavorite);
            return submitHeart("brand", designer, "add").then(function () {
                $.modal({
                    triggerOpen:true,
                    open: "favorite-button"
                });
            }).then(function () {
                return reloadFavoriteDesignerList(gender, tab);
            });
        }
    }
}

function reloadFavoriteDesignerList(gender, tab) {
  if(location.pathname.indexOf('/content/lp/beauty/shop-by-brand/mobile') !== -1){
    return; // do not reload designerlist on shop by beauty brand page
  }

  var data = $.param({
      gender: gender,
      tab: tab
  });
  $.ajax({
    type: 'GET',
    url: '/r/ajax/reloadFavoriteDesignerList.jsp',
    data: data,
    success: function (rtn) {
      if (rtn.trim()) {
        if (!$("#menu-title").is(":visible")) {
          $("#menu-title").show();
          $('.js-fav-info').hide();
        }
      } else {
        if ($("#menu-title").is(":visible")) {
          $("#menu-title").hide();
          $('.js-fav-info').show();
        }
      }
        if (window.rcProps.redesignedMarkup) {
            $('.js-fav-designer').remove();
            $('#menu-title').after(rtn);
        } else {
            $('#favorite-designer-list').html(rtn);
        }
    }
  });
}

function submitHeart(paramtype, paramvalue, action, psize, sectionUrl, callback, elem, activeClass) {
  var data = {};
  var heartInfo = {};

  if (!paramtype) {
    return rejectPromise('param type is required when hearting a product');
  } else if (!paramvalue) {
    return rejectPromise('param value is required when hearting a product');
  } else if (!action) {
    return rejectPromise('action is required when hearting a product');
  }

  switch (paramtype) {
    case 'product':
      data.pcode = paramvalue;
      break
    case 'brand':
      data.bcode = paramvalue;
      break
  }

  data.action_T = action;
  var department = $("#tr_top_heart_mhp_count").data('department');
  if (department) {
    data.mensBrand = encodeURIComponent(department.toLowerCase() === "mens");
    data.kidsBrand = encodeURIComponent(department.toLowerCase() === "kids");
  }

  if (psize) {
    data.psize = psize;
  }

  if (sectionUrl) {
    data.sectionURL = sectionUrl;
  }

  if(paramtype == 'product') {
    if(typeof gaUpdateHeartItem === 'function'){
      gaUpdateHeartItem(action,paramvalue);
    }
    if(typeof taboolaWishListAction === 'function'){
        taboolaWishListAction(action,paramvalue);
    }
    if(typeof iPinYouHeartItem === 'function' && action != 'undefined' && action === 'add' ){
      iPinYouHeartItem(paramvalue);
    }
    if(typeof insertRTBHouseHeartItem === 'function' && action != 'undefined' && action === 'add' ){
      insertRTBHouseHeartItem(paramvalue);
    }
  } else if(paramtype == 'brand'){
    if(typeof gaUpdateHeartBrand === 'function'){
      gaUpdateHeartBrand(action,paramvalue);
    }
  }

  return requestHeartProduct(data)
    .then(function(heartStatus) {
      if (heartStatus.exceedsLimit) {
        showExceedsLimitModal(paramvalue);
          if (typeof window.updateSwatchHeart === 'function') {
              window.updateSwatchHeart(data.pcode, false);
          }
      } else if (heartStatus.success) {
          if(typeof callback == 'function'){
              callback();
          }
        updateHeartCount(heartStatus.count);
        if(action =='add' && paramtype=='product' && elem && activeClass) {
            $(elem).addClass(activeClass);
          }
      }

      return heartStatus;
    }).then(function(heartStatus) {
      if (heartStatus && heartStatus.count == 0 && location.pathname.indexOf('/mr_favorites.jsp') !== -1) {
          const redirectUrl = "/content/myfav/onboarding/mobile?d=" + department;
          window.location.replace(redirectUrl);
      }
      if(action =='add' && paramtype=='product') {
          insertCordialUpdateHeartItem('add', paramvalue);
      }
      if(action == 'remove' && paramtype=='product') {
          insertCordialUpdateHeartItem('remove', paramvalue);
      }

      if(paramtype === 'brand') {
          if(typeof brazeBrandFavorites === 'function') {
              brazeBrandFavorites(heartStatus.action, heartStatus.brandName, heartStatus.brandId);
          }
      } else if(paramtype === 'product') {
          if (typeof brazeAddToFavorites === 'function') {
              brazeAddToFavorites(action,
                  heartStatus.code,
                  heartStatus.name,
                  heartStatus.size,
                  heartStatus.imageUrl,
                  heartStatus.productUrl,
                  heartStatus.price,
                  heartStatus.currency,
                  heartStatus.department,
                  heartStatus.color,
                  heartStatus.brandName,
                  heartStatus.category,
                  heartStatus.cat1
              );
          }
      }
      return true;
    });
}

function sanitizeResponse(str) {
  return str.replace(/^\s+|\s+$/g,'');
}

function rejectPromise(msg) {
  return $.Deferred().reject(new Error(msg));
}

function requestHeartProduct(data) {
  if (window.rcProps.isApp) {
    window.location.href = "/AppHeartProductIntercept.jsp?" + $.param(data);
  } else {
    return $.ajax({
      type: REQUESTS.heartProduct.method,
      url: REQUESTS.heartProduct.url,
      data: data
    })
      .then(function (res) {
        return res;
      });
  }
}

function updateHeartCount(count) {
    if (count > 99) {
      $(SELECTORS.totalCount).html("99+");
    } else if (count === 0) {
      $(SELECTORS.totalCount).html(count);
      $('.fav-count--ab').hide();
    } else {
      $(SELECTORS.totalCount).html(count);
      $('.fav-count--ab').show();
    }

    $(SELECTORS.totalCount).data('count', count);
}

//this method only use in mobile display product page
function heartAll(elem){
  const activeClass = getActiveClass();

  if ($(elem).find('span').hasClass(activeClass)) {
    $('.fav_heart').removeClass(activeClass);
  } else {
    $('.fav_heart').addClass(activeClass);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/scripts/modules/heart-product.js